<!-- Breadcrumb -->
<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a routerLink="/dashboard" style="color: #003E53;">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Companies</li>
    </ol>
</nav>

<!-- Companies Table Card -->
<div class="row">
    <div class="col-xl-12">
        <app-card cardTitle="Basic Table" [options]="false" blockClass="table-border-style">

            <!-- Header: Title + Add Button -->
            <div class="row align-items-center mb-3 gx-2">
                <div class="col-9 col-md-6">
                    <h5 class="mb-0 text-dark fw-bold">Companies</h5>
                </div>
                <div class="col-3 col-md-6 d-flex justify-content-end">
                    <button type="button"
                        class="btn btn-sm btn-primary rounded-2 d-flex align-items-center justify-content-center p-0"
                        (click)="openModel('Add', null)" style="width: 22px; height: 22px;">
                        <mat-icon fontIcon="add" class="d-flex align-items-center justify-content-center"></mat-icon>
                    </button>
                </div>
            </div>

            <hr class="m-0 p-0">

            <!-- Search Input -->
            <div class="row">
                <div class="col-12">
                    <mat-form-field class="dense w-100">
                        <mat-label>Search By Name</mat-label>
                        <input matInput name="name" (keyup)="filter($event)" class="w-100">
                    </mat-form-field>
                </div>
            </div>

            <!-- Table -->
            <div class="table-responsive">
                <div class="mat-elevation-z8">
                    <table mat-table [dataSource]="dataSource" class="table-bordered compact-table">

                        <!-- Sr. No Column -->
                        <ng-container matColumnDef="position">
                            <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                            <td mat-cell *matCellDef="let row; let index = index">
                                {{ index + 1 + (paginator.pageIndex * paginator.pageSize) }}
                            </td>
                        </ng-container>

                        <!-- Name -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>Name</th>
                            <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                        </ng-container>

                        <!-- Logo -->
                        <ng-container matColumnDef="logo">
                            <th mat-header-cell *matHeaderCellDef>Logo</th>
                            <td mat-cell *matCellDef="let element">
                                <img [src]="getImg(element.trimImage)" alt="Company logo" class="logo-img">
                            </td>
                        </ng-container>

                        <!-- Email -->
                        <ng-container matColumnDef="email">
                            <th mat-header-cell *matHeaderCellDef>Email</th>
                            <td mat-cell *matCellDef="let element">{{ element.email }}</td>
                        </ng-container>

                        <!-- Phone -->
                        <ng-container matColumnDef="phone">
                            <th mat-header-cell *matHeaderCellDef>Phone</th>
                            <td mat-cell *matCellDef="let element">{{ element.phone }}</td>
                        </ng-container>

                        <!-- Created At -->
                        <ng-container matColumnDef="createdAt">
                            <th mat-header-cell *matHeaderCellDef class="text-nowrap">Created At</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.createdAt | date: 'dd/MM/yyyy' }}<br>
                                <small>{{ element.createdAt | date: 'hh:mm a' }}</small>
                            </td>
                        </ng-container>

                        <!-- Status -->
                        <ng-container matColumnDef="isBlocked">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Status</th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <ng-toggle [value]="!element.isBlocked"
                                    [color]="{ unchecked: '#939da2', checked: '#006B88' }"
                                    (click)="onToggleClick(element)" [width]="30" [height]="15">
                                </ng-toggle>
                            </td>
                        </ng-container>

                        <!-- Samples -->
                        <ng-container matColumnDef="samples">
                            <th mat-header-cell *matHeaderCellDef class="text-nowrap text-center">Samples</th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <button mat-icon-button class="btn btn-sm"
                                    [routerLink]="['/company/samples', element._id]">
                                    <mat-icon class="c_btn">visibility</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <!-- View Recipients -->
                        <ng-container matColumnDef="viewRecipients">
                            <th mat-header-cell *matHeaderCellDef class="text-nowrap text-center">Network</th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <a [routerLink]="['/company/distribution/network', element._id]"
                                    class="btn btn-sm c_btn" aria-label="View Network">
                                    <i class="bi bi-diagram-3 fs-5"></i>
                                </a>
                            </td>
                        </ng-container>

                        <!-- Actions -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="text-center">Action</th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <div class="d-flex align-items-center gap-1 justify-content-center flex-nowrap">
                                    <mat-icon fontIcon="edit" class="c_btn"
                                        (click)="openModel('Edit', element._id)"></mat-icon>
                                </div>
                            </td>
                        </ng-container>

                        <!-- Table Rows -->
                        <tr mat-header-row *matHeaderRowDef="companyDisplayedColumns" class="t_head p-1"></tr>
                        <tr mat-row *matRowDef="let row; columns: companyDisplayedColumns;" class="p-1"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell text-center" [attr.colspan]="companyDisplayedColumns.length">
                                No data available
                            </td>
                        </tr>

                    </table>
                </div>
            </div>

            <!-- Paginator -->
            <mat-paginator #paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50, 100]"
                (page)="getAllCompanies($event)">
            </mat-paginator>
        </app-card>
    </div>
</div>

<!-- Modal Form -->
<div class="modal fade" id="companyModal" tabindex="-1" aria-labelledby="companyModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

            <div class="modal-header border-1 pb-0">
                <h5 class="modal-title fs-5 fw-semibold" id="companyModalLabel">{{ formType }} Company</h5>
                <button type="button" class="btn-close" (click)="hideModel()"></button>
            </div>

            <div class="modal-body pt-3">
                <form [formGroup]="companyForm" (ngSubmit)="submit()">
                    <div class="row g-2">

                        <!-- Company Name -->
                        <div class="col-md-6">
                            <label class="form-label fw-semibold text-muted small">Company Name</label>
                            <input type="text" formControlName="name" class="form-control form-control-sm py-1"
                                placeholder="Enter Company Name">
                            @if (companyForm.get('name')?.invalid && (companyForm.get('name')?.touched ||
                            companyForm.get('name')?.dirty)) {
                            <small class="text-danger">Name is required</small>
                            }
                        </div>

                        <!-- Phone -->
                        <div class="col-md-6">
                            <label class="form-label fw-semibold text-muted small">Phone</label>
                            <input type="number" formControlName="phone" class="form-control form-control-sm py-1"
                                placeholder="Enter Phone Number" inputmode="numeric" maxlength="10" minlength="10">
                            @if (companyForm.get('phone')?.invalid && (companyForm.get('phone')?.touched ||
                            companyForm.get('phone')?.dirty)) {
                            <small class="text-danger">Enter a valid 10-digit phone number</small>
                            }
                        </div>

                        <!-- Email -->
                        <div [ngClass]="formType === 'Edit' ? 'col-md-12' : 'col-md-6'">
                            <label class="form-label fw-semibold text-muted small">Email</label>
                            <input type="email" formControlName="email" class="form-control form-control-sm py-1"
                                placeholder="Enter Email">
                            @if (companyForm.get('email')?.invalid && (companyForm.get('email')?.touched ||
                            companyForm.get('email')?.dirty)) {
                            <small class="text-danger">Email is required</small>
                            }
                        </div>

                        <!-- Password -->
                        @if (formType !== 'Edit') {
                        <div class="col-md-6">
                            <label class="form-label fw-semibold text-muted small">Password</label>
                            <input type="password" formControlName="password" class="form-control form-control-sm py-1"
                                placeholder="Enter Password">
                            @if (companyForm.get('password')?.invalid && (companyForm.get('password')?.touched ||
                            companyForm.get('password')?.dirty)) {
                            <small class="text-danger">Password is required</small>
                            }
                        </div>
                        }

                        <!-- Logo -->
                        <div class="col-12">
                            <label class="form-label fw-semibold text-muted small">Company Logo</label>
                            <input type="file" #fileInput (change)="uploadImage($event)"
                                class="form-control form-control-sm py-1">
                        </div>

                    </div>

                    <!-- Modal Footer -->
                    <div class="modal-footer border-1 pt-3 d-flex justify-content-end">
                        <button type="button" class="btn btn-sm btn-light me-2" (click)="hideModel()">Cancel</button>
                        <button type="submit" class="btn btn-sm btn-primary px-3"
                            [disabled]="formType === 'Add' && companyForm.invalid">Save</button>
                    </div>
                </form>
            </div>

        </div>
    </div>
</div>